import { type Route } from '@angular/router';
import {
	channelGuard,
	configurationLoginGuard,
	ConfigurationLoginComponent,
} from '@pressteaze/auth';
import { ConfigurationHomeComponent } from './configuration-home.component';

export const appRoutes: Route[] = [
	{
		path: 'login',
		component: ConfigurationLoginComponent,
		canActivate: [configurationLoginGuard],
	},
	{
		path: '',
		component: ConfigurationHomeComponent,
		canActivate: [channelGuard('configuration')],
	},
	{ path: '**', redirectTo: '' },
];
